<template>
    <div class="home">
        <div id="userinfo" v-if="showModel === 'showBaseinfo'">
            <van-cell-group title="转入中心信息">
                <van-cell title="申请职工账号" :value="grzh" />
                <van-cell title="申请职工姓名" :value="xingming" />
                <van-cell title="证件类型" :value="zjlxCN" />
                <van-cell title="证件号码" :value="zjhm" />
                <van-cell title="申请日期" :value="riqi" />
                <!--<van-cell title="职工联系方式" :value="zglxfs" />-->
                <van-field
                    v-model="zglxfs"
                    type="tel"
                    clearable
                    label="职工联系方式"
                    placeholder="请输入..."
                    input-align="right"
                    maxlength="11"
                    @input="checkForm('zglxfs')"
                    class="van-require-patch"
                />
                <van-cell title="转入单位账号" :value="zrdwzh" />
                <van-cell title="转入单位名称" :value="zrdwmc" />
                <van-cell title="归集银行" :value="gjyh" />
                <van-cell title="收款机构" :value="skjg" />
                <van-cell title="收款银行" :value="skyh" />
                <van-cell title="收款账户" :value="skzh" />
                <van-cell title="收款户名" :value="skhm" />
                <van-cell title="转入地中心联系方式" :value="zrdzxlxfx" />

                <van-cell title="转入单位名称" :value="inunitname" v-if="isGetLoaninfo" />
            </van-cell-group>
            <div class="agreementBtnBox">
                <van-button type="default" size="normal" :square="true" :block="true" color="#f03e3c" @click="next">下一步</van-button>
            </div>
        </div>

        <div id="transout" v-if="showModel === 'showForm'">
            <van-cell-group title="转入中心信息">
                <van-field
                    class="keyword-box"
                    v-model="keyword"
                    clearable
                    label=""
                    placeholder="转出中心名称模糊查询"
                    input-align="left"
                    maxlength="18"
                    @input="checkForm('keyword')"
                >
                    <van-button slot="button" size="small" type="primary" @click="getCenterInfo">查询</van-button>
                </van-field>
                <van-cell title="转出中心名称" is-link @click="onShowZCZX" :value="zczxmc" class="van-require-patch" />
                <van-popup v-model="showZCZX" position="bottom">
                    <van-picker v-if="showZCZX"
                                :columns="zczxList.text"
                                show-toolbar
                                title="转出中心名称"
                                @cancel="onCancelZCZX"
                                @confirm="onConfirmZCZX"
                    >
                    </van-picker>
                </van-popup>
                <van-cell title="转出中心编号" :value="zczxbh" v-show="zczxbh!==''"  class="van-require-patch" />
                <van-field
                    v-model="yzxgrzh"
                    clearable
                    label="原中心个人账号"
                    placeholder="请输入..."
                    input-align="right"
                    maxlength="20"
                    @input="checkForm('yzxgrzh')"
                    class="van-require-patch"
                />
                <van-field
                    v-if=""
                    v-model="ydwmc"
                    clearable
                    label="原单位名称"
                    placeholder="请输入..."
                    input-align="right"
                    maxlength="100"
                    @input="checkForm('ydwmc')"
                    class="van-require-patch"
                />
            </van-cell-group>
            <div class="agreementBtnBox">
                <van-button type="default" size="normal" :square="true" :block="true" color="#f03e3c" @click="submit">提交</van-button>
            </div>
        </div>

    </div>
</template>

<script>
import {Cell, CellGroup, Button, Field, Picker, Popup, DatetimePicker, Checkbox} from 'vant';
import 'vant/lib/cell/style';
import 'vant/lib/cell-group/style';
import 'vant/lib/button/style';
import 'vant/lib/field/style';
import 'vant/lib/picker/style';
import 'vant/lib/popup/style';
import 'vant/lib/datetime-picker/style';
import 'vant/lib/checkbox/style';

export default {
    name: "transferdiff",
    components: {
        vanCellGroup: CellGroup,
        vanCell: Cell,
        vanButton: Button,
        vanField: Field,
        vanPicker: Picker,
        vanPopup: Popup,
        vanDatetimePicker: DatetimePicker,
        vanCheckbox: Checkbox
    },
    mounted() {

    },
    data() {
        return {
            showModel: '',
            btUserInfo: null,
            grzh: '',
            __bind: null,

            baseinfo: null,
            xingming: '',
            zjhm: '',
            zjlx: '',
            zjlxCN: '',
            riqi: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
            zglxfs: '',
            zrdwzh: '',
            zrdwmc: '',
            gjyh: '',
            skjg: '',
            skyh: '',
            skzh: '',
            skhm: '',
            zrdzxlxfx: '',
            transIn: null,

            isGetLoaninfo: false, //
            zjlxDict: [
                {text: '身份证',  val: '01'},
                {text: '军官证',  val: '02'},
                {text: '护照',  val: '03'},
                {text: '外国人永久居住证',  val: '04'},
                {text: '其他',  val: '09'},
            ],
            keyword: '',
            yzxgrzh: '',
            ydwmc: '',
            zczxmc: '请选择',
            showZCZX: false,
            zczxList: {
                text: [],
                value: []
            },
            zczxbh: '',

        }
    },
    created(){
        let self = this;
        console.log('store====>', this.$store.state.btUserInfo);
        self.btUserInfo = this.$store.state.btUserInfo;
        self.grzh = self.$store.state.accountNumber.accountNumber;
        self.tel = self.$store.state.btUserInfo.tel;
        // self.getAccLoginInfo();
        this.getInfo();
    },
    methods: {
        // 1 查询账户信息
        getAccLoginInfo(){
            let self = this;
            self.$http.post('/miapp/A3109/mpaasgatewayunencrypted' , {
                ybmapMessage: {
                    username: self.btUserInfo.userName, //证件号码
                    pwd: '',
                    zjhm: self.btUserInfo.zjhm,
                    dllx: '1',
                    yzm:''
                }
            }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                let _bind = typeof res.__bind === 'string' ? JSON.parse(res.__bind) : res.__bind;
                self.__bind = _bind;
                self.grzh = _bind.surplusAccount;
                self.ajaxLoginData = res;
                self.getInfo();
            }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
            });
        },
        // 2  公积金账户基本信息查询
        getInfo(){
            let self = this;
            self.$http.post('/miapp/A2001/mpaasgatewayunencrypted' , {
                buztype: 5001,
                usertype: 10,
                ybmapMessage: {
                    cxlx: '03',
                    cxlxz: self.grzh
                }
            }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                    // self.showModel = 'showBaseinfo';
                    self.xingming = self.returnFieldValue(res.result, 'xingming');
                    self.zjhm = self.returnFieldValue(res.result, 'zjhm');
                    /*self.zjlx = self.$store.state.btUserInfo.zjlx;
                    self.zjlxCN = self.zjlxDict.filter(item => {
                        return item.val === self.$store.state.btUserInfo.zjlx;
                    })[0].text;*/
                    self.zglxfs = self.returnFieldValue(res.result, 'sjhm');
                    self.baseinfo = res;
                    console.log(JSON.stringify(res.result));
                    self.getTransferIn();
                } else {
                    self.$utils.alert(res.msg);
                    self.$utils.loading(false);
                }

            }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
            });
        },
        // 3、查询转入中心信息
        getTransferIn(){
            let self = this;
            self.$http.post('/miapp/A6014/mpaasgatewayunencrypted' , {
                ybmapMessage: {
                    grzh: self.grzh
                }
            }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                    self.showModel = 'showBaseinfo';
                    self.transIn = res;
                    self.zjlx = res.zjlx;
                            self.zjlxCN = self.zjlxDict.filter(item => {
                        return item.val === res.zjlx;
                    })[0].text;
                    self.zrdwzh = res.dwzh;
                    self.zrdwmc = res.dwmc;
                    self.gjyh = res.skyh;
                    self.skjg = res.skjg;
                    self.skyh = res.skyh;
                    self.skzh = res.skzh;
                    self.skhm = res.skhm;
                    self.zrdzxlxfx = res.zxlxfs;
                    // self.baseinfo = res;
                } else {
                    self.$utils.alert(res.msg);
                    self.$utils.loading(false);
                }

            }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
            });
        },
        getCenterInfo(){
            let self = this;
            if(self.keyword === ''){
                self.$utils.alert('请输入转出中心名称关键字');
                return false;
            }
            self.$http.post('/miapp/A6015/mpaasgatewayunencrypted' , {
                ybmapMessage: {
                    zczxmcjx: self.keyword
                }
            }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                    res.result.forEach(item => {
                        self.zczxList.text.push(item.zczxmc);
                        self.zczxList.value.push(item.zczxbh);
                    });
                    self.isGetLoaninfo = res.result.length > 0 ? true : false;
                    console.log(self.zczxList);
                } else {
                    self.$utils.alert(res.msg);
                    self.$utils.loading(false);
                }

            }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
            });
        },
        onShowZCZX(){
            if(!this.isGetLoaninfo){
                this.$utils.alert('请先查询转出中心名称');
                return false;
            }
            this.showZCZX = true;
        },
        onCancelZCZX(){
            this.showZCZX = false;
        },
        onConfirmZCZX(value, index){
            console.log(value, index);
            this.zczxmc = value;
            this.zczxbh = this.zczxList.value[index];
            this.showZCZX = false;
        },
        next(){
            let self = this;
            if(!/^1\d{10}$/.test(self.zglxfs)){
                self.$utils.alert('职工联系方式输入有误');
                return false;
            }
            this.showModel = 'showForm';
        },

        checkForm(arg){
            if(arg === 'zglxfs'){

            }
        },

        submit(){
            let self = this;
            if(!self.isGetLoaninfo){
                self.$utils.alert('请先查询公积金转入单位名称');
                return false;
            }
            if(self.zczxmc === '' || self.zczxmc === '请选择'){
                self.$utils.alert('请选择转出中心名称');
                return false;
            }
            if(self.zczxbh === ''){
                self.$utils.alert('查询转出中心编号有误，请重新查询');
                return false;
            }
            if(self.yzxgrzh === ''){
                self.$utils.alert('原中心个人账号不能为空');
                return false;
            }
            if(self.ydwmc === ''){
                self.$utils.alert('原单位名称不能为空');
                return false;
            }
            self.$http.post('/miapp/A6016/mpaasgatewayunencrypted' , {
                buztype: '7008',
                ybmapMessage: {
                    grzh: self.grzh,
                    channel: '21',
                    coreUserid: self.btUserInfo.coreUserid,
                    zxlxfs: self.zrdzxlxfx,
                    zczxbh: self.zczxbh,
                    zczxmc: self.zczxmc,
                    ygrzh: self.yzxgrzh,
                    ydwmc: self.ydwmc,
                    sjhm: self.zglxfs
                }
            }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                    self.$utils.alert('业务办理成功', function(){
                        // window.history.go(-1);
                    });
                    self.doReport();
                } else {
                    self.$utils.alert(res.msg);
                    self.$utils.loading(false);
                }
                self.isGetLoaninfo = false;
            }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
            });
        },
        doReport(){
            let self = this;
            console.log('baitong', self.$store.state.baitong);
            self.$http.post('/miapp/C0001/mpaasgatewayunencrypted', {
                "accessToken": self.$store.state.baitong.userAccessToken,
                "openId": self.$store.state.btUserInfo.openId,
                "idCard": self.$store.state.btUserInfo.idCard,
                "reportedData": {
                    "serviceId": "个人异地转移",
                    "ywName": "个人异地转移",
                    "statusNo": "1",
                    "eventName": "个人异地转移提交",
                    "orderId": self.$store.state.btUserInfo.idCard + Date.parse(new Date()),
                    "remark": "",
                    "detailInfo": {
                        "APPLICANT_NAME": self.$store.state.btUserInfo.userName,
                        "APPLY_DATE": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                        "ORG_NAME": "南通市住房公积金中心",
                        "process": [
                            {
                                "END_TIME": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                                "EVENT_NAME": "个人异地转移",
                                "START_NOTE": "通过",
                                "START_TIME": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                                "START_USER_NAME": "南通市住房公积金中心"
                            }
                        ],
                        "statuNO": "1",
                        "smtApplyFile":[]
                    }
                }
            }, {loading: false}).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){

                } else {
                    self.$utils.alert(res.msg || '业务上报失败');
                }
            }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
            });
        },


        isCnNewID(cid){
            var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
            var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
            if(/^\d{17}\d|x$/i.test(cid)){
                var sum = 0, idx;
                for(var i = 0; i < cid.length - 1; i++){
                    // 对前17位数字与权值乘积求和
                    sum += parseInt(cid.substr(i, 1), 10) * arrExp[i];
                }
                // 计算模（固定算法）
                idx = sum % 11;
                // 检验第18为是否与校验码相等
                return arrValid[idx] == cid.substr(17, 1).toUpperCase();
            }else{
                return false;
            }
        },



        returnFieldValue: function(data, name){
            return data.filter(function(item, index){
                if(item.name == name){
                    return item.info;
                }
            })[0].info;
        },


        routingTo(target){
            let self = this;
            self.$router.push({
                path: '/' + target,
                query: {
                    'openweb': 'paschybrid'
                }
            });
        }
    }
};
</script>
<style scoped>
.agreement {padding:0;font-size:.3rem;line-height:.46rem;background:#ffffff;}
.agreement-text {padding: 0 .3rem .22rem;}
.agreement h3 {font-size:.44rem;text-align:center;line-height:.62rem;font-weight:500;padding:.2rem 0;}
.agreement h4 {font-size:.38rem;text-indent:2em;font-weight:500;line-height:.54rem;}
.agreement p {text-indent:2em;text-align:justify;}
.common-form-input li > span {position: relative;}
.common-form-input li > span.is-required::before { position:absolute;content: '*';font-size: .2rem;top: .22rem;z-index: 2;left: 5px;color: #ff0000;display: block;}
#app {padding-bottom:0;}
</style>
<style lang="stylus">
body
    background #e5e5e5
.van-field__label
    width auto
    text-overflow ellipsis
    padding-right 12px
.van-require-patch
    position relative
    width 100%
    &:before
        position absolute
        left 18px
        color #ee0a24
        font-size .32rem
        content '*'
</style>
<style lang="stylus" scoped>
.van-cell:not(:last-child)::after
    left 0
.blank
    height .2rem
    display block
.van-cell-group__title
    color #518ede
    font-weight 400
.btn-wrap
    display flex
.van-field
    flex-wrap nowrap
.van-button--normal
    margin .3rem auto .2rem
.van-checkbox
    align-items flex-start
    padding .24rem .3rem
.van-icon
    border-radius 3px
.select-bank
    border-top solid 1px #ebedf0
.agreementBtnBox
    display flex
.van-cell
    display flex
    justify-content space-between
    align-items center
.van-cell__title, .van-cell__value
    flex auto
.van-cell__value
    word-break break-all
.keyword-box
    padding-left .24rem
</style>